export default function Female({ color = "#f29d8b" }) {
  return (
    <svg id="female-sign-svgrepo-com" xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24">
      <path id="Path_34251" data-name="Path 34251" d="M21.127,8.147a8.085,8.085,0,0,0-8-8.147,8.086,8.086,0,0,0-8,8.147,8.123,8.123,0,0,0,6.317,7.966v1.9H9.665a1.586,1.586,0,0,0,0,3.171h1.78V22.42a1.557,1.557,0,1,0,3.114,0V21.18h1.869a1.586,1.586,0,0,0,0-3.171H14.559V16.166A8.145,8.145,0,0,0,21.127,8.147Zm-12.9,0a4.9,4.9,0,1,1,4.895,4.987A4.946,4.946,0,0,1,8.231,8.147Z" transform="translate(-5.127)" fill={color} />
    </svg>

  );
}
